export default "__VITE_ASSET__DqjXwJo7__"